import React from 'react';
import PropTypes from 'prop-types';

import { DialogActions as MUIDialogActions } from '@mui/material';

export const DialogActions = props => <MUIDialogActions {...props} />;

DialogActions.propTypes = {
  classes: PropTypes.object,
  disableSpacing: PropTypes.bool
};

export default DialogActions;
